import script from "./CustomCakeCategoryPage.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomCakeCategoryPage.vue?vue&type=script&setup=true&lang=js"

import "./CustomCakeCategoryPage.vue?vue&type=style&index=0&id=906feedc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-906feedc"]])

export default __exports__